module.exports = __webpack_public_path__ + "img/C06TechBiremeChampion_ua.af78cb88.webp";